import styled from 'styled-components'

type Props = {
  children: JSX.Element | JSX.Element[]
  className?: string
}

export const Layout = ({ children, className }: Props): JSX.Element => {
  return (
    <Container className={className}>
      <Content>{children}</Content>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  padding: 0;
`

const Content = styled.div<{ children: JSX.Element | JSX.Element[] }>`
  display: flex;
  flex-flow: row nowrap;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  padding: 0;
`
